<template>
    <div v-if="userConfirmationManager.state.isVisible" class="overlay">
        <div class="message-box">
            <p>{{userConfirmationManager.state.message}}</p>
        </div>
    </div>
</template>

<script>
    import { userConfirmationManager } from './UserConfirmationManager';

    export default {
        setup() {
            return {
                userConfirmationManager
            };
        }
    };
</script>

<style scoped>
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 1000;
        pointer-events: none;
    }

    .message-box {
        background-color: #202037;
        color: #fff;
        padding: 20px 40px;
        border-radius: 10px;
        text-align: center;
        max-width: 90%;
        pointer-events: auto;
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
        font-size: 2vw;
    }
</style>